module.exports = __webpack_public_path__ + "img/ol_no_icon.4c98379f.png";